/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { WidgetProps } from '@rjsf/utils';
import { Widgets } from '@rjsf/primereact';

const RjsfSelectWidget = Widgets.SelectWidget;

/**
 * Overrides the default @rjsf/primereact SelectWidget to append the overlay
 * panel inside the dropdown's own DOM (appendTo="self"). This keeps the panel
 * within the surrounding Dialog focus-trap so the dropdown does not lose focus
 * (or auto-hide) when scrolling inside the overlay.
 */
export const SelectWidget: React.FC<WidgetProps> = (props) => {
  const prime = (props.options?.prime ?? {}) as Record<string, unknown>;
  const options = {
    ...props.options,
    prime: { appendTo: 'self', ...prime }
  };
  return <RjsfSelectWidget {...props} options={options} />;
};
